/** @file Writes keys picked in the graph into the shared selection, pinning the curves on screen. */
import { selectionStore } from '../../stores/selectionStore';
import type { KeyRef } from '../../stores/types';
import { keySelection } from '../timeline/model/keySelection';
import type { CurveRef } from './curveTypes';
import { curveViewStore } from './curveViewStore';

/**
 * Replaces the selected keys (or toggles them in with `add`, keeping each key once). The refs on screen are pinned first,
 * so a graph click never hides the other curves; a selection written by anyone else clears the pins.
 */
export function writeCurveSelection(keys: readonly KeyRef[], add: boolean, shown: readonly CurveRef[]): void {
  const next = keySelection.apply(selectionStore.getState().keys, keys, add ? 'toggle' : 'replace');
  curveViewStore.setState({ pinned: [...shown], ownKeys: next });
  selectionStore.setState({ keys: next });
}
